import { logo } from "assets/images";
import React from "react";
import { Link } from "react-router-dom";
import "./Footer.scss";
import { useTranslation } from "react-i18next";
const Footer = () => {
  const navLinks = [
    { key: 1, text: "About Us", url: "/about-us" },
    { key: 2, text: "FAQs", url: "/pricing" },
    { key: 3, text: "Contact Us", url: "/contact-us" },
    { key: 4, text: "Terms of Service", url: "/terms-of-service" },
    { key: 5, text: "Privacy Policy", url: "/privacy-policy" },
  ];
  const { t } = useTranslation();
  return (
    <>
      <footer className="footer">
        <div className="container">
          <div className="footer_content">
            <div className="item">
              <img src={logo} alt="" />
              <p>{t("HOME-FOOTER.footerDescription")}</p>
            </div>
            <div className="item">
              <h3>{t("HOME-FOOTER.resource")}</h3>
              <ul>
                {navLinks.map((link, index) => (
                  <li key={link?.url || index}>
                    <Link to={link?.url || ""}>
                      {t(`HOME-FOOTER.${link?.text}`) || ""}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="item">
              <h3>{t("HOME-FOOTER.connectWithUs")}</h3>
              <ul>
                <li>
                  <Link to="">X</Link>
                </li>
                <li>
                  <Link to="">{t("HOME-FOOTER.linkedIn")}</Link>
                </li>
              </ul>
            </div>
            <div className="item">
              <h3>{t("HOME-FOOTER.contact")}</h3>
              <ul>
                <li>
                  <a href="mail:hello@cashbased.com">
                    {t("HOME-FOOTER.footerEmail")}
                  </a>
                </li>
                <li>
                  <a href="tel:(866) 334-3572">
                    {t("HOME-FOOTER.footerNumber")}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="copyright">
            <p>{t("HOME-FOOTER.copyright")}</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
